import { TNewOrderForm } from "@/entities/new-order";
import { Flex } from "@mantine/core";
import { useFormContext } from "react-hook-form";
import CountryReviewDateItem from "./country-review-date-item";

interface CountryReviewsDateListProps {
  currentIndex: number;
  update: (
    index: number,
    value: TNewOrderForm["countriesList"][number],
  ) => void;
}

function CountryReviewsDateList({
  currentIndex,
  update,
}: CountryReviewsDateListProps) {
  const { watch } = useFormContext<TNewOrderForm>();

  const { countriesList } = watch();

  const country = countriesList[currentIndex];

  return (
    <Flex direction="column" gap="sm">
      {Object.entries(country.keywords).map(([date], index) => (
        <CountryReviewDateItem
          key={`${date}-${index}`}
          currentIndex={currentIndex}
          groupId={`${currentIndex}-${index}-${date}`}
          date={date}
          update={update}
        />
      ))}
    </Flex>
  );
}

export default CountryReviewsDateList;
